import React from 'react';
import { Button } from '@cityelectricalfactors/ui-components';
import { DownloadIcon } from 'assets/common_svgs';
import TabTextbox from '../tab_textbox';
import FilePicker from './file_picker';

const UploadListForm = () => (
  <div className="quick-orders__form fl fl-col ai-fe">
    <TabTextbox showIcon showSeparator>
      <p className="nm">
        When formatting your product list, simply insert all product Part/Stock
        codes in the 1st column, and the quantity you require in the 2nd column.
        Ensure that all products/quantities are listed vertically to prevent
        formatting errors.
      </p>
    </TabTextbox>
    <TabTextbox className="mb-28">
      <div className="fl fl-col m-fl-row">
        <p className="nm">Don’t have a product list file?</p>
        <a className="fl ai-c m-ml-16 td-u" href="test">
          <DownloadIcon cn="mr-5" />
          Download our List Template
        </a>
      </div>
    </TabTextbox>
    <FilePicker />
    <Button
      className="submit__btn fs-16 fw-500 mt-36 mb-32 cef-btn cef-btn--green"
      label="Upload Product List"
      disabled>
      Upload Product List
    </Button>
  </div>
);

export default UploadListForm;
